import { Button } from '@/components/ui/button';
import { useWorkspaceActions } from '@/hooks/workspace/useWorkspaceActions';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

export const PasteToTaskButton = () => {
    const navigate = useNavigate();
    const workspaceActions = useWorkspaceActions();

    const handlePasteToTask = useCallback(async () => {
        try {
            const pastedText = await navigator.clipboard.readText(); // Read directly from the clipboard
            if (!pastedText?.trim()) {
                toast.info("Clipboard is empty.");
                return;
            }

            const toastId = toast.loading("Analyzing pasted content...");
            const instructionsForTask = "Task from clipboard";
            const response = await workspaceActions.pasteToTask({
                markdownContent: pastedText,
                instructions: instructionsForTask,
            });

            toast.dismiss(toastId);
            if (response?.action === "task_created" && response.taskId) {
                toast.success("Task created from pasted content!");
                navigate(
                    `/pages/review/?taskId=${response.taskId}&proposalId=${response.proposalId}`
                );
            } else if (response?.action === "no_action") {
                toast.info(response.message || "No action was taken for the pasted content.");
            }
        } catch (error: any) {
            if (error.name === 'NotAllowedError') {
                toast.error("Permission to read clipboard was denied.");
            } else {
                toast.error("Failed to process pasted content", {
                    description: error.message,
                });
            }
        }
    }, [navigate, workspaceActions]);

    return (
        <Button
            variant="outline"
            onClick={handlePasteToTask}
            size="sm"
            className="h-8 text-xs px-3"
        >
            Paste to Task
        </Button>
    );
};